import React from 'react';
import Temp from '../../assets/profile.svg';
import {User} from '../../types/users';
// import Delete from "../../assets/delete_white.svg";

interface Props {
    user: User
    onClick: () => void
}

export const ChatParticipantItem = ({user, onClick}: Props) => {
    return (
        <div
            onClick={onClick}
            className='flex relative !h-10 !w-10 flex-[0_0_auto] cursor-pointer'
        >
            {/*<div className={`absolute */}
            {/*    h-10 w-10*/}
            {/*    opacity-0*/}
            {/*    duration-300*/}
            {/*    bg-melon-grey*/}
            {/*    hover:opacity-80*/}
            {/*    transition-opacity flex justify-center items-center`}>*/}
            {/*    <img className={`object-cover`} src={Delete} alt="download file"/>*/}
            {/*</div>*/}
            <img className='rounded-full w-full h-full object-cover' src={user.photo_img?.file ?? Temp} alt='profile'/>
        </div>
    );
};
